import React from "react";
// Bootstrap
import { Well } from "react-bootstrap";
const AuthInfo = (props) => {
    return (React.createElement(Well, null, props.children));
};
export default AuthInfo;
